function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Outline_Old_Icons",
  "data-name": "Outline Old Icons"
}, React.createElement("path", {
  d: "M86.12,30.55a.6.6,0,0,0-.06-.19s0-.06,0-.09a1.28,1.28,0,0,0-.11-.2l0-.06a2,2,0,0,0-.19-.22L56.37.44a2.11,2.11,0,0,0-.23-.19l-.06,0a.93.93,0,0,0-.2-.1l-.09,0A1.06,1.06,0,0,0,55.6,0l-.3,0H1.5A1.5,1.5,0,0,0,0,1.5V114a1.5,1.5,0,0,0,1.5,1.5H84.65a1.5,1.5,0,0,0,1.5-1.5V30.85A1.53,1.53,0,0,0,86.12,30.55ZM56.8,5.12,81,29.35H56.8ZM3,112.5V3H53.8V30.85a1.5,1.5,0,0,0,1.5,1.5H83.15V112.5Zm28.82-57a7.57,7.57,0,0,0-4.93-1.42H20.14V73h4.43V66h2.32a7.57,7.57,0,0,0,4.93-1.42,5.59,5.59,0,0,0,2-4.54A5.5,5.5,0,0,0,31.82,55.54ZM28.4,62.08a3.44,3.44,0,0,1-2.13.52H24.54V57.54h1.73a3.51,3.51,0,0,1,2.13.52,2.37,2.37,0,0,1,.9,2A2.4,2.4,0,0,1,28.4,62.08Zm21.23-5.69a11,11,0,0,0-7.28-2.27H36V73h6.4a11.17,11.17,0,0,0,7.28-2.24,8.87,8.87,0,0,0,3.06-7.2A8.79,8.79,0,0,0,49.63,56.39ZM46.54,67.88a5.56,5.56,0,0,1-3.94,1.37H40.35V57.79H42.6a5.69,5.69,0,0,1,3.94,1.34,5.87,5.87,0,0,1,1.67,4.43A5.5,5.5,0,0,1,46.54,67.88Zm8.64-13.76H67v3.53H59.59v4.63h7V65.8h-7V73H55.18Z"
})));

var SvgPdf = function SvgPdf(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 86.15 115.5",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPdf, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pdf.c0e3d5d0.svg";
export { ForwardRef as ReactComponent };